import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { RecoilRoot } from "recoil";
import CopyConfirm from "./components/copy-confirm";

import PageRouter from "./pages/page-router";
function App() {
  return (
    <RecoilRoot>
      <Router>
        <div className="App">
          <CopyConfirm />
          <PageRouter />
        </div>
      </Router>
    </RecoilRoot>
  );
}

export default App;
